module.exports = __webpack_public_path__ + "static/media/003.b6774e7f.jpg";